import { cn } from '@mint-lib/tw-utils';
import { cva } from 'class-variance-authority';

const slateEditorStyles = cn(
  '**:data-[slate-placeholder=true]:text-text-secondary!',
  '**:data-[slate-placeholder=true]:text-sm!',
  '**:data-[slate-placeholder=true]:font-normal!',
  // [data-slate-editor] > * + *
  '[&_[data-slate-editor]>*+*:not(div)]:mt-4',

  // li, p
  '**:is(li,p):font-light',

  // strong
  '**:is(strong):font-semibold',

  // [role='textbox'] (descendant match for nested content wrapper)
  '**:is([role=textbox]):h-full',

  // [role='textbox']:focus-visible
  '**:is([role=textbox]):focus-visible:outline-none',

  // em
  '**:is(em):italic',

  // ol, ul
  '**:is(ol,ul):m-0',

  // li:not(:last-child)
  '**:is(li):not-last:mb-1.5',
);

export const editorWrapperVariants = cva(
  cn(
    'flex w-full flex-1 flex-col overflow-y-auto rounded-lg px-4 pt-2',
    'scrollbar-none [&::-webkit-scrollbar]:hidden',
    'h-auto max-h-40 min-h-[72px]',
    slateEditorStyles,
  ),
  {
    variants: {
      state: {
        error: 'border-2 border-error-main bg-ui-field02',
        disabled: 'bg-action-disabled border border-border-disabled',
        focused: 'border-2 border-action-focusBorder bg-ui-field02',
        readOnly: 'bg-ui-field border border-border-primary',
        default: 'border border-border-primary bg-ui-field02',
      },
      hover: {
        none: '',
        focused: 'hover:border-2 hover:border-action-focusBorder',
        readOnly: 'hover:border hover:border-border-primary',
        default: 'hover:border hover:border-action-focusBorder',
      },
    },
    defaultVariants: {
      state: 'default',
      hover: 'none',
    },
  },
);

export const getEditorState = (
  isUserCanSendMessage: boolean,
  isDisabled: boolean,
  isFocused: boolean,
  isReadOnlyAccess: boolean,
) => {
  if (!isUserCanSendMessage && !isDisabled) return 'error';
  if (isDisabled) return 'disabled';
  if (isFocused) return 'focused';
  if (isReadOnlyAccess) return 'readOnly';
  return 'default';
};

export const getHoverState = (
  isUserCanSendMessage: boolean,
  isFocused: boolean,
  isReadOnlyAccess: boolean,
) => {
  if (!isUserCanSendMessage) return 'none';
  if (isFocused) return 'focused';
  if (isReadOnlyAccess) return 'readOnly';
  return 'default';
};
